import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';

const ErrorModal = ({
    isOpen,
    onClose,
    isLoading,
    onSubmit,
}: {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    isLoading: boolean;
}) => {
    const translate = useTranslation();

    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader tabIndex={-1}>
                    <Text as="h3">{translate('list.modal.error.title')}</Text>
                </ModalHeader>
                <ModalCloseButton mt="2" isDisabled={isLoading} />
                <ModalBody fontSize="sm">{translate('list.modal.error.description')}</ModalBody>
                <ModalFooter>
                    <Button isDisabled={isLoading} variant="outline" size="sm" mr={3} onClick={onClose}>
                        {translate('list.upload.modal.cancel')}
                    </Button>
                    <Button isDisabled={isLoading} size="sm" mr={3} onClick={onSubmit} colorScheme="blue" bg="blueMain">
                        {translate('list.upload.modal.download_error_file')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ErrorModal;
